import React, { useEffect } from "react";
import { API_BASE_URL } from "../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./PaymentSuccess.css"; // Ensure this CSS file exists

const AppointmentPaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const bookAppointment = async () => {
      const sessionId = searchParams.get("session_id");
      const profileId = searchParams.get("profile_id");
      const doctorId = searchParams.get("doctor_id");
      const appointmentDate = searchParams.get("appointmentDate");
      const appointmentTime = searchParams.get("appointmentTime");
      const slotNumber = searchParams.get("slotNumber");
      const paymentMethod = searchParams.get("paymentMethod");
      const walletBalance = searchParams.get("walletBalance");
      const price = searchParams.get("price");
      const couponCode = searchParams.get("couponCode");

      console.log({
        sessionId,
        profileId,
        doctorId,
        appointmentDate,
        appointmentTime,
        slotNumber,
        paymentMethod,
        walletBalance,
        price,
        couponCode
      });

      try {
        const response = await fetch(
          `${API_BASE_URL}/slots/book`,
          {
            method: "POST",
            body: JSON.stringify({
              patientId: profileId,
              doctorId: doctorId,
              appointmentDate: appointmentDate,
              appointmentTime: appointmentTime,
              slotNumber: slotNumber,
              paymentMethod: paymentMethod,
              price: price,
              couponCode: couponCode
            }),
          }
        );

        const data = await response.json();
        if (data.statusCode === 1) {

          const appointmentId = data.payLoad.appointmentId;
          const successUrl = `${API_BASE_URL}/stripe/appointment-payment-success?session_id=${sessionId}&profile_id=${profileId}&doctor_id=${doctorId}&appointmentId=${appointmentId}&amount=${walletBalance}`;

          try {
            const response = await fetch(successUrl, {
              method: "GET",
            });

            if (!response.ok) {
              throw new Error(`Payment success API failed. Status: ${response.status}`);
            }

            const successData = await response.json();
            console.log("Payment success response:", successData);

            // Optionally handle the response, update UI, etc.

          } catch (error) {
            console.error("Error calling payment success API:", error);
          }

          // Optionally redirect or update UI here after success API call
        } else {
          alert(data?.statusMessage?.[0] || "Failed to book appointment.");
        }
        // console.log(response.data); // Handle the response as needed
      } catch (error) {
        console.error("Error booking appointment:", error);
      }
    };

    // Call the bookAppointment function if the required params are available
    if (searchParams.get("session_id")) {
      bookAppointment();
    }
  }, [searchParams]);

  return (
    <>
      <Navbar />
      <div className="payment-success-container">
        <img
          src="/payment-successful.png"
          alt="Payment Success"
          className="success-image"
        />
        <h2 style={{ color: "#00bcd4" }}>Payment Successful!</h2>
        <p>
          Thank you for booking the appointment. Your appointment has been
          booked successfully.
        </p>
        <button
          className="home-button"
          onClick={() => navigate("/bookedappointment")}
        >
          Go to Appointment Section
        </button>
      </div>
      <Footer />
    </>
  );
};

export default AppointmentPaymentSuccess;
